<div class="pipeline-space-particles" aria-hidden="true">
    @for (particle of particles(); track $index) {
        <span
            class="pipeline-particle"
            [style.top.%]="particle.top"
            [style.left.%]="particle.left"
            [style.width.px]="particle.size"
            [style.height.px]="particle.size"
            [style.animation-duration.s]="particle.duration"
            [style.animation-delay.s]="particle.delay"
            [style.--star-peak-opacity]="particle.peakOpacity"
            [style.--star-drift-x.px]="particle.driftX"
        ></span>
    }
    @for (star of stars(); track $index) {
        <span
            class="pipeline-shooting-star"
            [style.top.%]="star.top"
            [style.left.%]="star.left"
            [style.animation-duration.s]="star.duration"
            [style.animation-delay.s]="star.delay"
            [style.rotate.deg]="star.angle"
        ></span>
    }
</div>
